const ButtonData = [
  {
    name: "Action",
    id: 28,
    img:'./images/action.jpg'
  },
  {
    name: "Adventure",
    id: 12,
    img:'./images/adventure.jpg'
  },
  {
    name: "Animation",
    id: 16,
    img:'./images/animation.jpg'
  },
  {
    name: "Comedy",
    id: 35,
    img:'./images/comedy.jpg'
  },
  {
    name: "Crime",
    id: 80,
    img:'./images/crime.jpg'
  },
  {
    name: "Documentary",
    id: 99,
    img:'./images/documentary.jpg'
  },
  {
    name: "Drama",
    id: 18,
    img:'./images/drama.jpg'
  },
  {
    name: "Family",
    id: 10751,
    img:'./images/family.jpg'
  },
  {
    name: "Fantasy",
    id: 14,
    img:'./images/fantasy.jpg'
  },
  {
    name: "History",
    id: 36,
    img:'./images/history.jpg'
  },
  {
    name: "Horror",
    id: 27,
    img:'./images/horror.jpg'
  },
  {
    name: "Music",
    id: 10402,
    img:'./images/music.jpg'
  },
  {
    name: "Mystery",
    id: 9648,
    img:'./images/mystery.jpg'
  },
  {
    name: "Romance",
    id: 10749,
    img:'./images/romance.jpg'
  },
  {
    name: "Science Fiction",
    id: 878,
    img:'./images/sciencefiction.jpg'
  },
  {
    name: "Thriller",
    id: 53,
    img:'./images/thriller.jpg'
  },
  {
    name: "War",
    id: 10752,
    img:'./images/war.jpg'
  },
  {
    name: "Western",
    id: 37,
    img:'./images/western.jpg'
  },
]

export default ButtonData